<template>
  <jd-dialog align-center :visible.sync="visible" :show-close="true" :title="controlType == 'batch' ? '批量审核' : '审核'"
    :width="controlType == 'batch' ? '590px' : '800px'" @close="close" class="process-dailog">
    <div class="process-dialog-content">
      <template v-if="controlType == 'batch'">
        <jd-tip class="tip-bottom">
          <div>
            <p> 剩余可通过审核人数：{{ canProcessNum }} 当前已选择用户数：{{ proccessSelection.length }}</p>
          </div>
        </jd-tip>
        <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" class="batch-proccess-form">
          <el-form-item label="审核结果：" prop="processStatus" required>
            <el-radio-group v-model="formData.processStatus">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核备注：">
            <el-input type="textarea" class="text-arear-height" v-model="formData.processRemark" placeholder="输入审核结果备注" :maxlength="100" show-word-limit></el-input>
            <div v-if="isShowAuditResult">已设置审核通过结果可见，审核的备注将会展示给用户</div>
            <div v-else>已设置审核结果不可见，审核备注不会展示给用户</div>
          </el-form-item>
        </el-form>
      </template>
      <template v-else>
        <jd-tip class="tip-bottom">
          <div>
            <p> 剩余可通过审核人数：{{ canProcessNum }}</p>
          </div>
        </jd-tip>
        <div class="row-detail">
          <div class="row-item" v-if="rowData.chaosPin">
            <div class="row-item-label">用户pin:</div>
            <div class="row-item-value">{{ rowData.chaosPin }}</div>
          </div>
          <div class="row-item" v-if="rowData.chaosMemberNick">
            <div class="row-item-label">用户昵称:</div>
            <div class="row-item-value">{{ rowData.chaosMemberNick }}</div>
          </div>
          <div class="row-item" v-if="rowData.createTime">
            <div class="row-item-label">提交时间:</div>
            <div class="row-item-value">{{ rowData.createTime }}</div>
          </div>
          <div class="row-item" v-if="rowData.chaosName">
            <div class="row-item-label">姓名:</div>
            <div class="row-item-value">{{ rowData.chaosName }}</div>
          </div>
          <div class="row-item" v-if="rowData.chaosMobile">
            <div class="row-item-label">手机号:</div>
            <div class="row-item-value">{{ rowData.chaosMobile }}</div>
          </div>
          <div class="row-item" v-if="rowData.orderId">
            <div class="row-item-label">订单号:</div>
            <div class="row-item-value">{{ rowData.orderId }}</div>
          </div>
          <div class="row-item" v-if="rowData.chaosAddress">
            <div class="row-item-label">地址:</div>
            <div class="row-item-value">{{ rowData.chaosAddress }}</div>
          </div>
          <div class="row-item" v-if="rowData.chaosDetailedAddress">
            <div class="row-item-label">详细地址:</div>
            <div class="row-item-value">{{ rowData.chaosDetailedAddress }}</div>
          </div>
          <!-- <template v-if="rowData.parseExtendInfo">
            <div class="row-item" v-for="item,index in rowData.parseExtendInfo" :key="index">
              <div class="row-item-label">{{ item.name }}:</div>
              <template v-if="item.type == 2">
                <el-image :z-index="3032" style="width:60px;height: 60px;margin-left:10px" v-for="cItem,cIndex in item.value.split(',')" :src="cItem" :key="cIndex" :preview-src-list="[cItem]"/>
              </template>
              <div class="row-item-value" v-else>{{ item.value}}</div>
            </div>
          </template> -->
        </div>
        <div class="row-detail" v-if="rowData.parseExtendInfo">
          <div class="row-item1" v-for="item,index in rowData.parseExtendInfo" :key="index">
            <div class="row-item-label">{{ item.name }}:</div>
            <div class="row-item-list">
              <template v-if="item.type == 2">
                <div class="row-item-url" v-for="cItem,cIndex in item.value.split(',')" :key="cIndex">
                  <el-image class="commend-img" :src="cItem" :preview-src-list="[cItem]" :z-index="3032"></el-image>
                </div>
              </template>
              <div class="row-item-value" v-else>{{ item.value}}</div>
            </div>
          </div>
        </div>
        <div class="row-detail">
          <div class="row-item1" v-if="rowData.commentImage">
            <div class="row-item-label">评价截图:</div>
            <div class="row-item-list">
              <div class="row-item-url1" v-for="item, index in rowData.commentImage.split(',')" :key="index">
                <el-image class="commend-img" :src="item"  :preview-src-list="rowData.commentImage.split(',')" :z-index="3032"></el-image>
              </div>
            </div>
          </div>
        </div>
        <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" class="process-form">
          <el-form-item label="审核结果：" prop="processStatus" required>
            <el-radio-group v-model="formData.processStatus" :disabled="rowData.processStatus==1">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核备注：">
            <el-input class="text-arear-height" type="textarea" v-model="formData.processRemark" placeholder="输入审核结果备注" :maxlength="100" show-word-limit :disabled="rowData.processStatus==1"></el-input>
            <div v-if="isShowAuditResult">已设置审核通过结果可见，审核的备注将会展示给用户</div>
            <div v-else>已设置审核结果不可见，审核备注不会展示给用户</div>
          </el-form-item>
        </el-form>
      </template>
    </div>
    <span slot="footer" class="dialog-footer">
      <jd-button type="blue" @click="submit('ruleForm')" :loading="loading" :disabled="rowData.processStatus==1">确定</jd-button>
      <jd-button @click="close">取消</jd-button>
    </span>
  </jd-dialog>
</template>

<script>
import { processUserProfile, getCanProcessNum } from '@/api/jhk/politely'
/**晒单有礼-批量审核,单个审核*/
export default {
  name: "ProcessInfo",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    /**
     * 操作类型 batch 批量 single 单个
     */
    controlType: {
      type: String,
      default: 'single'
    },
    /**当前点击数据详情 */
    rowData: {
      type: Object,
      default: () => ({})
    },

    activityId: {
      type: String,
      default: ''
    },

    /**待审核份数 */
    unProcessNum: {
      type: [Number, String],
      default: 0,
    },

    /**批量审核选择的列表 */
    proccessSelection: {
      type: Array,
      default: () => []
    },
    /**审核备注展示 */
    isShowAuditResult: {
      type:Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      formData: {
        processRemark: '',
        processStatus: 1,
      },
      rules: {
        processStatus: [
          { required: true, message: '请选择审核结果', trigger: 'change' }],
      },

      canProcessNum: null, //剩余可通过审批人数
    };
  },
  watch: {
    value(val) {
      this.visible = val;
      if (val) {
        console.log(this.rowData)
        this._getCanProcessNum();
        if (this.controlType == 'single') {
          this.formData.processStatus = 1;
          this.formData.processRemark = '';
          if (this.rowData.processStatus !=0) {
            this.formData = {
              processRemark: this.rowData.processRemark,
              processStatus: this.rowData.processStatus,
            };
          }
        } else {
          this.formData = {
            processRemark: '',
            processStatus: 1,
          };
          this.$nextTick(() => {
            this.$refs['ruleForm'].clearValidate();
          })
        }
      }
    }
  },
  methods: {
    close() {
      this.$emit("input", false);
    },

    async _getCanProcessNum() {
      const res = await getCanProcessNum({
        activityId: this.activityId,
      })
      if(res.code == 1) {
        this.canProcessNum = res.data == null ? '无限' : res.data
      }
    },
    submit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if(this.controlType == 'batch' && this.formData.processStatus ==1) {
            if(this.canProcessNum !='无限' && this.proccessSelection.length > this.canProcessNum) {
              return this.$message.warning('当前选择用户数已超过剩余可通过用户数，请关闭弹窗重试')
            }
          }
          let params = {
            activityId: this.activityId,
            ...this.formData,
          }
          params.ids = this.controlType == 'batch' ? this.proccessSelection.map(item => item.id) : [this.rowData.id]
          console.log('params>>', params)
          this.loading = true;
          const res = await processUserProfile(params)
          this.loading = false;
          if (res.code == 1) {
            this.$message.success('操作成功');
            this.$emit('update')
            this.close();
          } else {
            this.$message.warning(res.message)
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
.el-image-viewer__wrapper {
  z-index: 4000 !important;
}
.process-form ,.batch-proccess-form {
  .el-textarea.is-disabled .el-textarea__inner {
    height: 120px !important;
    min-height: 120px !important;
  }
  .el-textarea__inner {
    height: 120px !important;
    min-height: 120px !important;
  }
}
</style>
<style scoped lang="scss">
.process-dialog-content {

  .row-detail {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    // margin-top: 24px;

    .row-item {
      display: flex;
      align-items: center;
      width: calc(33.33% - 20px / 3);
      padding: 10px 0px;
      margin-left: 10px;
      margin-bottom: 10px;

      &:nth-child(3n + 1) {
        margin-left: 0px;
      }

      .row-item-label {
        min-width: 86px;
        text-align: right;
      }

      .row-item-value {
        display: flex;
        align-items: center;
        margin-left: 10px;
      }
    }
    .row-item1 {
      width: 100%;
      display: flex;
      // align-items: center;
      padding: 10px 0px;
      margin-left: 10px;
      margin-bottom: 10px;

      &:nth-child(n) {
        margin-left: 0px;
      }

      .row-item-label {
        min-width: 86px;
        text-align: right;
      }
      .row-item-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .row-item-url {
          // width: 20%;
          display: flex;
          justify-content: center;
          align-items: center;
          .commend-img {
            width: 70px;
            height: 70px;
            margin-left: 10px;
          }
        }
        .row-item-url1 {
          // width: 20%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 8px;
          .commend-img {
            width: 70px;
            height: 70px;
            margin-left: 10px;
          }
        }
        .row-item-value {
          margin-left: 10px;
        }
      }
    }
  }

  .process-form {
    padding-top: 10px;
    border-top: 1px dashed #3333;

  }

  .batch-proccess-form {
    margin-top: 10px;
  }


}
/deep/ .el-dialog {
  max-height: 780px;
  overflow-y: auto;
}
</style>
